import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import chevronRight from 'assets/img/chevronRight.svg';
import calendar from 'assets/img/calendar.svg';
import RFPResponseStatus from 'types/RFPResponseStatus';
import Button from 'components/Button/Button';
import Tooltip from 'components/Tooltip/Tooltip';

import useInfoData from './hooks/useInfoData';

import './HeadInfo.scss';

export interface HeadInfoProps {}

const HeadInfo: FC<HeadInfoProps> = () => {
  const { t } = useTranslation();
  const { projectCounts, nextCloseDate } = useInfoData();

  return (
    <div className="enkrateia-dashobard-head-info">
      <div className="projects-summary">
        <div className="project-count general">
          <span>{projectCounts.all}</span>
          <span>{t('pages.dashboard.head.project', { count: projectCounts.all })}</span>
        </div>
        <div className="project-count open">
          <span>{projectCounts[RFPResponseStatus.OPEN]}</span>
          <span>{t('pages.dashboard.head.open')}</span>
        </div>
        <div className="project-count in-review">
          <span>{projectCounts[RFPResponseStatus.IN_REVIEW]}</span>
          <span>{t('pages.dashboard.head.inReview')}</span>
        </div>
        <div className="project-count final">
          <span>{projectCounts[RFPResponseStatus.FINAL]}</span>
          <span>{t('pages.dashboard.head.final')}</span>
        </div>
      </div>
      <div className="calendars">
        <div className="calendar">
          <label>{t('pages.dashboard.head.nextCloseDate')}</label>
          <span>{nextCloseDate.isValid ? nextCloseDate.toFormat('MMMM d, yyyy') : '-'}</span>
          <img src={chevronRight} alt="chevron right" />
        </div>
        <Tooltip tooltip={t('pages.dashboard.head.comingSoon')}>
          <Button variant="primary">
            <img src={calendar} alt="calendar" /> {t('pages.dashboard.head.calendar')}
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default HeadInfo;
